import {Component} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {DeploymentService} from "./deployment.service";
import {DialogService} from "../bootstrap-modal/dialog.service";
import {DialogComponent} from "../bootstrap-modal/dialog.component";
import {handleErrors} from "../misc/handle-errors.decorator";
import {SiteForDeploymentGqlModel} from "./deployment.gql-model";

export interface DeploymentCreateInputModel {
  projectId?: string;
  siteId?: string;
}

@Component({
  templateUrl: "./deployment-create-dialog.template.pug",
  providers: [
    DeploymentService,
  ],
})
export class DeploymentCreateDialogComponent
  extends DialogComponent<DeploymentCreateInputModel, boolean>
  implements DeploymentCreateInputModel {
  error: Error;
  deploymentName: string;
  deploymentId: string;
  projectId: string;
  siteId: string;
  availableSites: SiteForDeploymentGqlModel[] = [];
  disableSiteSelecting: boolean = false;
  multiSiteDeployment: boolean = false;

  static showCreateDialog(dialogService: DialogService, input: DeploymentCreateInputModel): Promise<boolean> {
    return dialogService.showDialog(DeploymentCreateDialogComponent, input);
  }

  constructor(
    private deploymentService: DeploymentService,
    public route: ActivatedRoute,
    public router: Router,
    public dialogService: DialogService,
  ) {
    super(dialogService);
  }

  @handleErrors()
  async loadData(): Promise<void> {
    if (this.projectId) {
      this.availableSites = await this.deploymentService.getSitesEligibleForDeployment(this.projectId);

      if (this.availableSites.length === 1) {
        this.siteId = this.availableSites[0].siteId;
        this.disableSiteSelecting = true;
      }
    } else {
      throw new Error("Project ID is required to edit or create a deployment.");
    }
  }

  @handleErrors()
  async save(): Promise<void> {
    await this.deploymentService.createDeployment(
      this.deploymentName,
      this.projectId,
      (this.multiSiteDeployment ? undefined : this.siteId),
    );

    this.result = true;
    this.close();
  }

  cancel(): void {
    this.result = false;
    this.close();
  }

  ready(): void {
    this.loadData();
  }
}
